

export default {
  list: {
    padding: 0,
  }
}
